import type { SingleRecordResponse } from '~/types'
import type { BoxScore } from '~/types/models/boxscore'

export const useBoxScoreApi = () => {
  const show = async (streamId: string, include: BoxScore.Include[] = []) => {
    return useApiGet<SingleRecordResponse<BoxScore.FullModel>>(`schedule-events/${streamId}/boxscore`, {
      params: {
        include,
      },
    })
  }

  return { show }
}
